import React, { FC } from 'react';
import { Card, CardContent, CardProps } from './Card';

/**
 * A SimpleCard is a vanilla card with no bells or whistles.
 * It shortcuts the usage of <Card><CardContent></CardContent></Card>
 */
export const SimpleCard: FC<CardProps> = ({ children, ...cardProps }) => {
  return (
    <Card {...cardProps} isNotClickable>
      <CardContent>{children}</CardContent>
    </Card>
  );
};
